import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SuccessResponse } from 'src/app/common/models/SuccessRespons';
import { environment as env } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class QuotationService {
  private BASE_URL = `${env.PROPERTYBR_API_BASE_URL}/quotation`;

  private BASE_URL_AR = `${env.ARTICO_API_BR_BASE_URL}/api/v1`;

  constructor(private httpClient: HttpClient) {}

  save() {
    const URL = this.BASE_URL;
    return this.httpClient.post<SuccessResponse>(URL, {});
  }

  saveWithData(data) {
    const URL = this.BASE_URL;
    return this.httpClient.post<SuccessResponse>(URL, data);
  }

  update(data: any, id: string) {
    const URL = `${this.BASE_URL}/update/${id}`;
    return this.httpClient.put<SuccessResponse>(URL, data);
  }

  get(id: string) {
    const URL = `${this.BASE_URL}/find/${id}`;
    return this.httpClient.get<SuccessResponse>(URL);
  }

  remove(id: string) {
    const URL = `${this.BASE_URL}/remove/${id}`;
    return this.httpClient.get<SuccessResponse>(URL);
  }

  find(typeFilter: string, dataCode: string, offset: string = '0', limit: string = '10') {
    const URL = `${this.BASE_URL}/find-proposals?offset=${offset}&limit=${limit}&sort=${typeFilter}&filter=${dataCode}`;
    return this.httpClient.get<SuccessResponse>(URL);
  }

  verifyClient(data: any) {
    const URL = `${this.BASE_URL_AR}/compliance/verify?codEmpresa=BR`;
    return this.httpClient.post<SuccessResponse>(URL, data);
  }

  queryProperties(data: any, id: string) {
    const URL = `${this.BASE_URL}/query-properties/${id}`;
    return this.httpClient.put<SuccessResponse>(URL, data);
  }

  calculatePrices(data: any, id: string) {
    const URL = `${this.BASE_URL}/calculate-prices/${id}`;
    return this.httpClient.put<SuccessResponse>(URL, data);
  }

  syncProposals() {
    const URL = `${this.BASE_URL}/sync-proposals`;
    return this.httpClient.put<SuccessResponse>(URL, {});
  }
}
